// Analytics / GA4 (GTM)
// Empurra o evento `purchase` no dataLayer NO MÁXIMO 1x por transaction_id.
// Evita doação contada em dobro no GA4 por duplo-submit, reclique ou reload
// da página de agradecimento. Dedup por sessionStorage (sobrevive a reload da aba).
export function pushPurchaseOnce(payload) {
  var txId = payload && payload.ecommerce && payload.ecommerce.transaction_id;
  if (txId == null) return;

  var key = "auc_purchase_sent";
  var sent = [];
  try {
    sent = JSON.parse(sessionStorage.getItem(key) || "[]");
  } catch (e) {
    sent = [];
  }

  // já enviamos o purchase desta doação -> ignora a duplicata
  if (sent.indexOf(txId) !== -1) return;

  try {
    sessionStorage.setItem(key, JSON.stringify(sent.concat(txId)));
  } catch (e) {
    // sem sessionStorage: segue e empurra mesmo assim (melhor enviar do que perder a conversão)
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

export default pushPurchaseOnce;
